import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { ListadaAgrupada } from '../../../infrastructure/services/config.service';
import { LoaderService } from '../../../infrastructure/services/loader.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sx-listado-desplegable',
  templateUrl: './dropdownList.component.html',
  styleUrls: ['./dropdownList.component.css'],
})
export class ListadoDesplegableComponent implements OnInit, OnDestroy {
  @Input('fuente') fuente: Observable<ListadaAgrupada[]>;
  @Input('tipo') tipo: String;
  @Input('btnDelete') btnDelete = false;

  @Output() clickDisabled: EventEmitter<any> = new EventEmitter();

  grupos: ListadaAgrupada[] = new Array<ListadaAgrupada>();
  subscripcion: Subscription;
  constructor(
    public loader: LoaderService,
    public router: Router,
    public aRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.subscripcion = this.fuente.subscribe((grupos) => {
      this.grupos = grupos;
    });
  }
  onClickDisabled() {
    this.clickDisabled.emit();
  }

  ngOnDestroy() {
    if (this.subscripcion) {
      this.subscripcion.unsubscribe();
    }
  }
  volver() {
    this.aRoute.params.subscribe((params) => {
      if (
        params['codoutput'] != undefined ||
        params['codproducto'] != undefined ||
        params['codnegocio'] != undefined ||
        params['codsistema'] != undefined
      )
        this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
      else this.router.navigate(['../../'], { relativeTo: this.aRoute.parent });
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/dropdownList/dropdownList.component.ts